import update from 'react-addons-update';
import {
  QUOTING_GOOGLE_MAP,
  QUOTING_ADDRESS_1,
  QUOTING_ADDRESS_2,
  QUOTING_SET_VEHICLE_PRICE,
  QUOTING_IS_GET_QUOTE,
  IS_DRAGGING_MAP,
  QUOTING_IS_NO_SERVICE,
} from '../constants';

export default function quoting(state = null, action) {
  if (state === null) {
    return {
      map: null,
      isDraggingMap: false,
      address1: {
        address: '',
        lat: 0,
        lon: 0,
      },
      address2: {
        address: '',
        lat: 0,
        lon: 0,
      },
      vehiclePrice: {},
      isGetQuote: false,
      isNoQuotingService: false,
    };
  }

  switch (action.type) {
    case QUOTING_GOOGLE_MAP:
      return {
        ...state,
        map: action.payload,
      };
    case IS_DRAGGING_MAP:
      return {
        ...state,
        isDraggingMap: action.payload,
      };
    case QUOTING_ADDRESS_1:
      return {
        ...state,
        address1: action.payload,
      };
    case QUOTING_ADDRESS_2:
      return {
        ...state,
        address2: action.payload,
      };
    case QUOTING_IS_GET_QUOTE:
      return {
        ...state,
        isGetQuote: action.payload,
      };
    case QUOTING_IS_NO_SERVICE:
      return {
        ...state,
        isNoQuotingService: action.payload,
      };
    case QUOTING_SET_VEHICLE_PRICE:
      return update(state, {
        vehiclePrice: {
          [action.vehicle]: {
            $set: action.price,
          },
        },
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/quoting.js